import {
  Paper,
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
} from "@mui/material";
import {
  LOOKUP_TN_EXAMPLES,
  LookupTnExampleProps,
} from "./lookupTnExamplesData";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const LookupTnExamples = () => {
  return (
    <>
      <Paper sx={{ padding: 4, borderRadius: 2, mt: 4 }} elevation={4}>
        <Box sx={{ flexDirection: "column" }}>
          <Typography variant="h4">Result Examples</Typography>
          <Typography variant="h6" sx={{ mt: 2 }}>
            Please click on a header to expand
          </Typography>
        </Box>
        {LOOKUP_TN_EXAMPLES.map((ex) => (
          <LookupTnExample {...ex} />
        ))}
      </Paper>
    </>
  );
};

const LookupTnExample = ({
  header,
  description,
  exampleResponse,
  italicsEnding,
}: LookupTnExampleProps) => {
  return (
    <Accordion sx={{ mt: 4 }}>
      <AccordionSummary
        id="panel1-header"
        expandIcon={<ExpandMoreIcon fontSize="large" />}
      >
        <Typography variant="h5">{header}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container>
          <Grid size={6}>
            <Box className="lookup-tn-results-json-container">
              <Box className="lookup-tn-results-json-text fixed-width-text">
                {exampleResponse}
              </Box>
            </Box>
          </Grid>
          <Grid size={6} sx={{ p: 4 }}>
            <Typography variant="subtitle1">{description}</Typography>
            {italicsEnding ? (
              <Typography className="italic">{italicsEnding}</Typography>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};
